function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompletedTask = function SvgCompletedTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Completed box"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 172"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    "data-name": "Rectangle 1510",
    style: {
      fill: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 163"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m474.595 511.174-2.663-2.7 1.017-1.033 1.649 1.673 3.8-3.861 1.017 1.033z",
    "data-name": "Path 649",
    style: {
      fill: "#fff"
    },
    transform: "translate(-464.725 -496.751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.208 514.139a5.738 5.738 0 1 0-5.739-5.738 5.738 5.738 0 0 0 5.739 5.738zm0 1.162a6.9 6.9 0 1 0-6.9-6.9 6.9 6.9 0 0 0 6.9 6.899z",
    "data-name": "Path 650",
    style: {
      fillRule: "evenodd",
      fill: "#fff"
    },
    transform: "translate(-465.119 -497.314)"
  }))));
};
export default SvgCompletedTask;